// Utilitaires pour détecter la plateforme (web vs electron)

export const isElectron = (): boolean => {
    // Vérifier si on est dans Electron
    return !!(window as any).require && !!(window as any).process?.type;
};

export const isWeb = (): boolean => {
    // Vérifier si on est dans le navigateur web
    return process.env.REACT_APP_PLATFORM === 'web' || !isElectron();
};

export const getPlatform = (): 'electron' | 'web' => {
    return isElectron() ? 'electron' : 'web';
};